import { frontendURL } from '../../../helper/URLHelper';
import OpportunitiesIndex from './pages/OpportunitiesIndex.vue';
import OpportunityDetailView from './pages/OpportunityDetailView.vue';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

const commonMeta = {
  permissions: ['administrator', 'agent'],
  installationTypes: [
    INSTALLATION_TYPES.COMMUNITY,
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
  ],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/opportunities'),
    component: OpportunitiesIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'opportunities_dashboard_index',
        component: OpportunitiesIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/opportunities/:opportunityId'),
    component: OpportunityDetailView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'opportunities_dashboard_show',
        component: OpportunityDetailView,
        meta: commonMeta,
      },
    ],
  },
];
